// Update the global widget state
export interface SetWidgetFormErrorAction {
  type: "SET_WIDGET_FORM_ERROR";
  data: {
    path: string;
    errorMessage: string | null;
  };
}

export function setWidgetFormError(
  path: string,
  errorMessage: string | null
): SetWidgetFormErrorAction {
  return {
    type: "SET_WIDGET_FORM_ERROR",
    data: { path, errorMessage },
  };
}
